import React from "react";

export default function NFTLevelProgress({
  currentLevel = 3,
}) {
  const levels = [
    {
      level: 1,
      referrals: 5,
      team: 5,
    },
    {
      level: 2,
      referrals: 6,
      team: 10,
    },
    {
      level: 3,
      referrals: 7,
      team: 15,
    },
    {
      level: 4,
      referrals: 8,
      team: 20,
    },
    {
      level: 5,
      referrals: 9,
      team: 25,
    },
  ];

  return (
    <div className="w-full px-2 py-4">
      {/* 进度条 */}
      <div className="flex items-center">
        {levels.map((item, index) => (
          <React.Fragment key={item.level}>
            {/* 节点 */}
            <div className="flex flex-col items-center relative">
              <div
                className={`
                  w-9 h-9 rounded-full
                  flex items-center justify-center
                  text-[12px] font-bold
                  transition-all duration-500

                  ${
                    item.level < currentLevel
                      ? "bg-[#F5B932] text-black shadow-[0_0_15px_rgba(245,185,50,.7)]"
                      : item.level === currentLevel
                      ? "bg-[#F5B932] text-black animate-levelPulse shadow-[0_0_25px_rgba(245,185,50,.9)]"
                      : "bg-[#131313] border border-[#444] text-[#666]"
                  }
                `}
              >
                +1
              </div>

              <div className="mt-2 text-center">
                <div className="text-[10px] text-white">
                  L{item.level}
                </div>

                <div className="text-[8px] text-gray-500 mt-1">
                  {item.referrals} Ref
                </div>

                <div className="text-[8px] text-gray-500">
                  {item.team} BNB
                </div>
              </div>
            </div>

            {/* 连线 */}
            {index < levels.length - 1 && (
              <div className="flex-1 h-[4px] mx-1 rounded-full relative overflow-hidden">
                <div className="absolute inset-0 bg-[#222]" />

                <div
                  className={`
                    absolute inset-0 transition-all duration-500

                    ${
                      item.level < currentLevel
                        ? "bg-gradient-to-r from-[#F5B932] to-[#FFD978]"
                        : ""
                    }
                  `}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      
    </div>
  );
}